<template>
  <v-container fluid pa-0>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-container fluid py-0 pb-1>
          <v-row align="center">
            <div>
              <h1 class="headline">Template Types</h1>
            </div>
            <v-col class="py-0"> </v-col>
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    fab
                    dark
                    color="primary"
                    @click="onCreateNew"
                  >
                    <v-icon dark>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Create New Template Type</span>
              </v-tooltip>
            </div>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          item-key="id"
          class="elevation-1"
          fixed-header
          hide-default-footer
          :headers="filteredHeaders"
          :items="items"
          :loading="$apollo.loading"
          v-bind="pagingOptions"
          :search="search"
        >
          <template v-slot:item.notInUse="{ item }">
            <v-simple-checkbox
              v-model="item.notInUse"
              readonly
              dense
              hide-details
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.actions="{ item }">
            <default-list-actions
              :item="item"
              hideView
              @editItem="onEditItem"
              @deleteItem="onDeleteItem"
            /> </template
        ></v-data-table>
      </v-col>
    </v-row>
    <template-type-edit-dialog
      :show="showEditDialog"
      @close="showEditDialog = false"
      v-model="editedItem"
      @input="onSaveItem"
    />
  </v-container>
</template>

<script>
import { ListMixin } from "../../../../mixins/ListMixin";
import gql from "graphql-tag";

import { removeGQLTypename } from "../../../../helpers";
import DefaultListActions from "../../shared/DefaultListActions.vue";
import TemplateTypeEditDialog from "./TemplateTypeEditDialog.vue";
import { ref } from "vue";
const LIST_QUERY = gql`
  query allTemplateTypes(
    $filter: TemplateTypeFilterType
    $sort: SortOrderType
    $first: Int
  ) {
    templateTypes(filter: $filter, orderBy: $sort, first: $first) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          name
          description
          notInUse
        }
      }
    }
  }
`;
const DELETE_MUTATION = gql`
  mutation deleteTemplateType($id: ID!) {
    deleteTemplateType(id: $id) {
      id
    }
  }
`;
const CREATE_MUTATION = gql`
  mutation createTemplateType($input: TemplateTypeInput!) {
    createTemplateType(input: $input) {
      id
      name
      description
      notInUse
    }
  }
`;
const UPDATE_MUTATION = gql`
  mutation updateTemplateType($input: TemplateTypeInput!) {
    updateTemplateType(input: $input) {
      id
      name
      description
      notInUse
    }
  }
`;
export default {
  components: { DefaultListActions, TemplateTypeEditDialog },
  name: "template-type-list",

  mixins: [ListMixin],

  data() {
    return {
      debug: false,
      editedItem: null,
      visibleColumns: this.$store.getters.localSettings(this.$options.name, [
        "name",
        "description",
        "notInUse",
        "actions",
      ]),
      headers: [
        {
          text: "Name",

          value: "name",
          name: "name",
        },
        {
          text: "Description",
          value: "description",
          name: "description",
        },
        {
          text: "Not in Use",
          value: "notInUse",
          name: "notInUse",
        },
        {
          text: "Actions",
          value: "actions",
          name: "actions",
        },
      ],
      showEditDialog: false,
    };
  },

  computed: {
    items() {
      return this.templateTypes && this.templateTypes.edges
        ? this.templateTypes.edges.map(removeGQLTypename)
        : [];
    },
  },

  methods: {
    onCreateNew() {
      //console.log("Create New Template Type");
      this.editedItem = null;
      this.showEditDialog = true;
    },
    onEditItem(item) {
      console.log("Edit Template Type", item);
      this.editedItem = item;
      this.showEditDialog = true;
    },
    onDeleteItem(item) {
      console.log("Delete Template Type", item);
      this.$apollo
        .mutate({
          mutation: DELETE_MUTATION,
          variables: {
            id: item.id,
          },
          refetchQueries: [
            {
              query: LIST_QUERY,
              variables: {
                after: this.after,
                filter: {
                  ...this.searchParams,
                },
                sort: this.sort,
              },
            },
          ],
        })
        .then((data) => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Template Type Deleted.",
          });
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
    onSaveItem(item) {
      this.showEditDialog = false;
      const mutation = item.id ? UPDATE_MUTATION : CREATE_MUTATION;
      this.$apollo
        .mutate({
          mutation,
          variables: {
            input: {
              ...item,
            },
          },
          refetchQueries: [
            {
              query: LIST_QUERY,
              variables: {
                after: this.after,
                filter: {
                  ...this.searchParams,
                },
                sort: this.sort,
              },
            },
          ],
        })
        .then((data) => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Template Type Saved.",
          });
          this.showItemEditor = false;
          this.editedItem = null;
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
  },

  apollo: {
    templateTypes: {
      query: LIST_QUERY,
      variables() {
        return {
          after: this.after,
          filter: {
            ...this.searchParams,
          },
          sort: this.sort,
        };
      },
      fetchPolicy: "network-only",
      result({ data }) {
        this.totalItems = data.templateTypes.totalCount;
      },
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/templates/template-types/TemplateTypeList.vue